import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useLectures = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["lectures", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.LECTURES.base}?${appendQueryParams({params})}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useLecturesFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["lecturesFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.LECTURES.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCreateLecture = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.LECTURES.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.LECTURES.base,
                token,
                body
            })
            return data
        },
    })
}

export const useUpdateLecture = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.LECTURES.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.LECTURES.base}/${id}`,
                token,
                body
            })
            return data
        },
    })
}

export const useDeleteLecture = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.LECTURES.base}/${id}`,
                token,
                toastError: true,
                toastMessage:true
            })
            return data
        },
    })
}